import { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import PropTypes from "prop-types";

@connect((state) => ({
  user: state.auth.user,
}))
class IssuePreviewProps extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: undefined,
      error: undefined,
    };

    this.handleRequestIssue = this.handleRequestIssue.bind(this);
  }

  async handleRequestIssue(issueId) {
    // Avoid duplicate requests
    if (this.state.data !== undefined) return;

    try {
      const [issueSummary, equipRules] = await Promise.all([
        axios.get(`/issue/${issueId}`).then((result) => {
          if (!result.data.key)
            throw Error(`No issue found with key ${issueId}`);
          return result.data;
        }),
        axios
          .post("/synco/issue/equipRules", {
            issueKeys: [issueId],
          })
          .then((result) => result.data[issueId]),
      ]);

      this.setState({
        loading: false,
        data: {
          ...issueSummary,
          relatedEquipRules: equipRules,
        },
      });
    } catch (err) {
      this.setState({
        loading: false,
        data: undefined,
        error: err.message,
      });
    }
  }

  render() {
    const { loading, data, error } = this.state;
    return this.props.children({
      loading,
      data,
      error,
      getPreview: this.handleRequestIssue,
    });
  }
}

IssuePreviewProps.propTypes = {
  issueId: PropTypes.string.isRequired,
  requestIssue: PropTypes.func,
  children: PropTypes.func.isRequired,
};

IssuePreviewProps.defaultProps = {
  requestIssue: () => {},
};

export default IssuePreviewProps;
